var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 147,
    height: 137,
    viewBox: "0 0 147 137",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.3333 0C63.7031 0 54.1671 1.8106 45.2699 5.32843C36.3727 8.84626 28.2885 14.0024 21.4788 20.5025C7.72617 33.6301 0 51.4348 0 70C0 100.94 21.0467 127.19 50.16 136.5C53.8267 137.06 55 134.89 55 133V121.17C34.6867 125.37 30.36 111.79 30.36 111.79C26.9867 103.67 22.22 101.5 22.22 101.5C15.5467 97.16 22.7333 97.3 22.7333 97.3C30.0667 97.79 33.9533 104.51 33.9533 104.51C40.3333 115.15 51.1133 112 55.2933 110.32C55.9533 105.77 57.86 102.69 59.9133 100.94C43.6333 99.19 26.5467 93.17 26.5467 66.5C26.5467 58.73 29.3333 52.5 34.1 47.53C33.3667 45.78 30.8 38.5 34.8333 29.05C34.8333 29.05 40.9933 27.16 55 36.19C60.7933 34.65 67.1 33.88 73.3333 33.88C79.5667 33.88 85.8733 34.65 91.6667 36.19C105.673 27.16 111.833 29.05 111.833 29.05C115.867 38.5 113.3 45.78 112.567 47.53C117.333 52.5 120.12 58.73 120.12 66.5C120.12 93.24 102.96 99.12 86.6067 100.87C89.2467 103.04 91.6667 107.31 91.6667 113.82V133C91.6667 134.89 92.84 137.13 96.58 136.5C125.693 127.12 146.667 100.94 146.667 70C146.667 60.8075 144.77 51.7049 141.085 43.2122C137.399 34.7194 131.997 27.0026 125.188 20.5025C118.378 14.0024 110.294 8.84626 101.397 5.32843C92.4996 1.8106 82.9636 0 73.3333 0Z",
    fill: "#F8F8F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavIcon2);
export default __webpack_public_path__ + "static/media/nav-icon2.1e19f4a5794e543794fc5d249eaffaad.svg";
export { ForwardRef as ReactComponent };